// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2LA-m","footer":"ModalCreateQualiphyProcedure_footer__FGfDp","additionData":"ModalCreateQualiphyProcedure_additionData__2ld8N"};